import Card from '..';
import { Programme } from '@edwin-group/cj-graphql';
import Button from '@/components/Button';

export const arrowProgrammeImg = '/card/arrow-programme.png';

const ProgrammeCard = ({
  programme,
  tags,
  seeMissionButtonText,
  onPressPlay,
}: {
  programme: Programme;
  tags: React.ReactNode;
  seeMissionButtonText: string;
  onPressPlay: () => void;
}) => {
  const CardButton = () => {
    return (
      <div className="rows-span-1 flex flex-col items-start gap-1">
        <Button theme="solid-primary-600" onClick={onPressPlay}>
          {seeMissionButtonText}
        </Button>
      </div>
    );
  };

  return (
    <Card
      key={programme.documentId}
      tags={tags}
      title={programme.name || ''}
      description={programme.description || ''}
      arrowImg={arrowProgrammeImg}
      image={{
        url: programme.image.url || '',
        alternativeText: programme.image.alternativeText || '',
      }}
      button={<CardButton />}
    />
  );
};

export default ProgrammeCard;
